module.exports = __webpack_public_path__ + "img/jingDian-1.1d972de1.jpg";